import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState, useRef } from "react";
import { ListaActividad } from "../../models/riesgo/ListaActividad";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Generico } from "../../components/Generico";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Actividad } from "./Actividad";
import { Amenaza } from "./Amenaza";
import { ControlImplementado } from "./ControlImplementado";
import { Evaluacion } from "./Evaluacion";
import { Contingencias } from "./Contingencias";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import { RiesgoChart } from "./RiesgoChart";
import { PromedioRiesgo } from "./PromedioRiesgo";
import { ActividadesOrden } from "./ActividadesOrden";
import { MapaCalorRiesgo } from "./MapaCalorRiesgo";
import { toPng } from 'dom-to-image-more';
import { Accordion, AccordionTab } from "primereact/accordion";
import { CriteriosGeneral } from "./CriteriosGeneral";
import { ConsecuenciasGeneral } from "./ConsecuenciasGeneral";
import { Menu } from "primereact/menu";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

export const Actividades = ({ riesgo, permss, toast, generic, regresar, descargar, funcionalidades }) => {
    const omodel = new ListaActividad();
    const [registros, setRegistros] = useState(null);
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const [item, setItem] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const { table, loading: loadingTabla, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers: registros, generic, permss, omodel });
    const [dialogActividad, setDialogActividad] = useState(false);
    const [dialogCriterioConsecuencia, setDialogCriterioConsecuencia] = useState(false);
    const [dialogChart, setDialogChart] = useState(false);
    const [dialogPromedio, setDialogPromedio] = useState(false);
    const [datosGrafico, setDatosGrafico] = useState([]);
    const [dialogMapaCalor, setDialogMapaCalor] = useState(false);
    const [dialogOrdenarActividades, setDialogOrdenarActividades] = useState(false);
    const [siguienteTab, setSiguienteTab] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [loadingNext, setLoadingNext] = useState(false);
    const [loadingReporte, setLoadingReporte] = useState(false);
    const [loadingEnviarFinalizar, setLoadingEnviarFinalizar] = useState(false);
    const [loadingDescargarGrafico, setLoadingDescargarGrafico] = useState(false);
    const [labelMatriz, setLabelMatriz] = useState(null);
    const [refrescarGrafico, setRefrescarGrafico] = useState(0);
    const menuRef = useRef(null);
    const graficoRef = useRef(null);
    const graficoRiesgosRef = useRef(null);
    const graficoPromedioRiesgosRef = useRef(null);
    const graficoMapaRiesgoInherenteRef = useRef(null);
    const graficoMapaRiesgoResidualRef = useRef(null);

    const tiposCriterio = [
        { tipo: 'MTR_RIESGO_ACTIVIDAD', nombre: 'Actividad', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_AREA', nombre: 'Área', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_MACRO_TIPO', nombre: 'Macro Tipo', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_MACRO_CAT', nombre: 'Macro Categoría', listar: 'ninguno', padre: 'MTR_RIESGO_MACRO_TIPO' },
        { tipo: 'MTR_RIESGO_PROCESO', nombre: 'Proceso', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_SUBPROCESO', nombre: 'Subproceso', listar: 'ninguno', padre: 'MTR_RIESGO_PROCESO' },
        { tipo: 'MTR_RIESGO_FUENTE_RIESGO', nombre: 'Fuente de Riesgo', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_RIESGO', nombre: 'Riesgo', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_CAUSA_RIESGO', nombre: 'Causa de Riesgo', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_TRATAMIENTO', nombre: 'Tratamiento', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_CTRL_IMPLEMENTADO', nombre: 'Control Implementado', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_CONTROL_AYUDA', nombre: 'Control de Ayuda', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_ACTOR_INTERNO', nombre: 'Actor Interno', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_ACTOR_EXTERNO', nombre: 'Actor Externo', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_MONITOREO_REVISION', nombre: 'Monitoreo / Revisión', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_MENSAJE', nombre: 'Mensaje', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_CANAL', nombre: 'Canal', listar: 'ambos' },
        { tipo: 'MTR_RIESGO_CUANDO', nombre: 'Cuándo', listar: 'ambos' },
    ];

    const tiposConsecuencia = [
        { tipo: 'MTR_RIESGO_CONSECUENCIA', nombre: 'Descripcion de la Consecuencia (Impacto)' },
        { tipo: 'MTR_RIESGO_PROBABILIDAD', nombre: 'Probabilidad del riesgo' },
        { tipo: 'MTR_RIESGO_CSC_RIESGO_CONTAGIO', nombre: 'Consecuencia Contagio' },
        { tipo: 'MTR_RIESGO_CSC_LEGAL', nombre: 'Consecuencia Legal' },
        { tipo: 'MTR_RIESGO_CSC_OPERATIVO', nombre: 'Consecuencia Operativa' },
        { tipo: 'MTR_RIESGO_CSC_REPUTACIONAL', nombre: 'Consecuencia Reputacional' },
        { tipo: 'MTR_RIESGO_RANQUEO', nombre: 'Ranqueo' },
        { tipo: 'MTR_RIESGO_TIPO_CONTROL', nombre: 'Tipo de Control' },
        { tipo: 'MTR_RIESGO_EJECUCION_CONTROL', nombre: 'Tipo de Ejecución de Control' },
        { tipo: 'MTR_RIESGO_FRECUENCIA_CONTROL', nombre: 'Frecuencia del Control' },
        { tipo: 'MTR_RIESGO_SOLIDEZ_CONTROL', nombre: 'Solidez del Control' },
        { tipo: 'MTR_RIESGO_EFECTIVIDAD_CONTROL', nombre: 'Efectividad del Control' },
    ];

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const transformarDatosGrafico = (registros) => {
        const siglas = Array.from(new Set(registros.map(item => "ID " + item.sigla_riesgo)));
        siglas.sort((a, b) => {
            const na = parseInt(a.replace("ID ", ""), 10);
            const nb = parseInt(b.replace("ID ", ""), 10);
            return na - nb
        });
        const mapInherente = {};
        const mapResidual = {};
        registros.forEach(item => {
            const key = "ID " + item.sigla_riesgo;
            if (item.riesgo_inherente != null) {
                mapInherente[key] = parseFloat(item.riesgo_inherente);
            }
            if (item.riesgo_residual != null) {
                mapResidual[key] = parseFloat(item.riesgo_residual);
            }
        });
        const inherente = siglas.map(sigla => ({ sigla_riesgo: sigla, valor: mapInherente[sigla] ?? 0 }));
        const residual = siglas.map(sigla => ({ sigla_riesgo: sigla, valor: mapResidual[sigla] ?? 0 }));
        return [{ label: 'Riesgo Inherente', valores: inherente }, { label: 'Riesgo Residual', valores: residual }]
    }

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.id = riesgo?.id;
        _lazyParams.tipo_area_id = riesgo?.tipo_area_id;
        delete _lazyParams.rtipo;
        if (labelMatriz == null) {
            _lazyParams.rtipo = true;
        }
        matrizSrv.listado('matriz-riesgo-detalle/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setDatosGrafico(transformarDatosGrafico(res.data.registros));
            if (res.data.titulo !== undefined) {
                setLabelMatriz(res.data.titulo);
            }
            setLoading(false);
            setRefrescarGrafico(prev => prev + 1);
        });
    }

    const confirm = (_delete) => {
        let message = '¿Está seguro de realizar esta acción?';

        if (_delete) {
            message = '¿Está seguro de eliminar la información?';
        } else {
            switch (item?.nemonico) {
                case 'BORRADOR':
                    message = '¿Está seguro de enviar la actividad?';
                    break;
                case 'ENVIADO':
                    message = '¿Está seguro de finalizar la actividad?';
                    break;
                default:
                    message = '¿Está seguro de continuar con esta acción?';
            }
        }
        confirmDialog({
            group: 'eliminar-riesgo',
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => _delete ? eliminar() : finalizar()
        });
    }

    const finalizar = () => {
        setLoadingEnviarFinalizar(true);
        matrizSrv.editar({ id: item?.id, idp: riesgo?.id, nemonico: item?.nemonico }, 'matriz-riesgo-detalle/aprobar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoadingEnviarFinalizar(false);
        });
    }

    const confirmarVolver = (destino) => {
        let message = '';

        switch (destino) {
            case 'ENVIADO':
                message = '¿Está seguro de volver la actividad a estado enviado?';
                break;
            case 'BORRADOR':
                message = '¿Está seguro de volver la actividad a estado borrador?';
                break;
            default:
                message = '¿Está seguro de continuar con esta acción?';
        }

        confirmDialog({
            group: 'eliminar-riesgo',
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => volverEstado()
        });
    };

    const volverEstado = () => {
        setLoadingEnviarFinalizar(true);
        matrizSrv.editar({ id: item?.id, idp: riesgo?.id, nemonico: item?.nemonico }, 'matriz-riesgo-detalle/volver-estado').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoadingEnviarFinalizar(false);
        });
    };

    const eliminar = () => {
        const detalleId = item?.id;
        const matrizId = riesgo?.id;
        const idCompuesto = `${detalleId}/${matrizId}`;
        matrizSrv.eliminar(idCompuesto, 'matriz-riesgo-detalle/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const editar = () => {
        setDialogActividad(true);
    }

    const itemsMenu = () => {
        const items = [];
        const deshabilitarEnviarFinalizar = loadingReporte || loadingEnviarFinalizar;
        const deshabilitarVolver = loadingReporte || loadingEnviarFinalizar;
        // Estado BORRADOR
        if (item?.nemonico === 'BORRADOR') {
            if (permss?.actualizar)
                items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar(); } });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-ENVIAR-ACTIVIDAD'))
                items.push({ label: 'Enviar', icon: 'pi pi-send', command: () => { confirm(false); }, disabled: deshabilitarEnviarFinalizar });
            if (permss?.eliminar)
                items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirm(true); } });
        }
        // Estado ENVIADO
        if (item?.nemonico === 'ENVIADO') {
            if (permss?.consultar)
                items.push({ label: 'Imprimir Actividad', icon: 'pi pi-print', command: () => generarReporte(item, 'actividad'), disabled: loadingReporte, });
            if (permss?.actualizar)
                items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar(); } });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-FINALIZAR-ACTIVIDAD'))
                items.push({ label: 'Finalizar', icon: 'pi pi-check', command: () => { confirm(false); }, disabled: deshabilitarEnviarFinalizar });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-VOLVER-BORRADOR-ACTIVIDAD'))
                items.push({ label: 'Volver a Borrador', icon: 'pi pi-undo', command: () => { confirmarVolver('BORRADOR'); }, disabled: deshabilitarVolver });
        }
        // Estado FINALIZADO
        if (item?.nemonico === 'FINALIZADO') {
            if (permss?.consultar)
                items.push({ label: 'Imprimir Actividad', icon: 'pi pi-print', command: () => generarReporte(item, 'actividad'), disabled: loadingReporte, });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-VOLVER-ENVIADO-ACTIVIDAD'))
                items.push({ label: 'Volver a Enviado', icon: 'pi pi-undo', command: () => { confirmarVolver('ENVIADO'); }, disabled: deshabilitarVolver });
        }
        return [{ label: 'Opciones', items }];
    };

    const nuevo = () => {
        setItem(null);
        setDialogActividad(true);
    }

    const generarReporte = (item, opcion) => {
        const descargarArchivo = opcion === 'matriz' && item?.nemonico === 'FINALIZADO';
        const url = descargarArchivo ? 'matriz-riesgo/descarga' : opcion === 'matriz' ? 'matriz-riesgo/reporte' : 'matriz-riesgo-detalle/reporte';
        const data = descargarArchivo ? `0/${item?.id}` : item?.id;
        const nombreArchivo = descargarArchivo ? `${item?.nombre} ${item?.sigla}.pdf` : opcion === 'matriz' ? 'Matriz-Riesgo.pdf' : 'Riesgo-Actividad.pdf';
        setLoadingReporte(true);
        descargar(url, data, nombreArchivo).finally(() => setLoadingReporte(false));
    }

    const nextPrev = (opcion = 'save') => {
        const botones = [];
        const agregarBoton = ({ key, label, icon, onClick, justify = 'center', type = 'button', loading = false, className }) => {
            botones.push(
                <div key={key} style={{ flex: 1, display: 'flex', justifyContent: justify }}>
                    <Button label={label} icon={icon} type={type} onClick={onClick} loading={loading} className={className} style={{ width: '120px' }} />
                </div>
            );
        };
        if (opcion === 'atras') {
            agregarBoton({ key: 'div-prev', label: 'Anterior', icon: 'pi pi-chevron-left', onClick: handlePrev, justify: 'flex-start' });
            agregarBoton({ key: 'div-save', label: 'Guardar', icon: 'pi pi-save', type: 'submit', loading: loadingSave, className: 'p-button-warning', justify: 'flex-end' });
        } else if (opcion === 'siguiente') {
            agregarBoton({ key: 'div-save', label: 'Guardar', icon: 'pi pi-save', type: 'submit', loading: loadingSave, className: 'p-button-warning', justify: 'flex-start' });
            agregarBoton({ key: 'div-next', label: 'Siguiente', icon: 'pi pi-chevron-right', type: 'submit', onClick: () => setSiguienteTab(true), loading: loadingNext, justify: 'flex-end' });
        } else if (opcion === 'ambos') {
            agregarBoton({ key: 'div-prev', label: 'Anterior', icon: 'pi pi-chevron-left', onClick: handlePrev, justify: 'flex-start' });
            agregarBoton({ key: 'div-save', label: 'Guardar', icon: 'pi pi-save', type: 'submit', loading: loadingSave, className: 'p-button-warning', justify: 'center' });
            agregarBoton({ key: 'div-next', label: 'Siguiente', icon: 'pi pi-chevron-right', type: 'submit', onClick: () => setSiguienteTab(true), loading: loadingNext, justify: 'flex-end' });
        } else if (opcion === 'solo-control-atras') {
            agregarBoton({ key: 'div-prev', label: 'Anterior', icon: 'pi pi-chevron-left', onClick: handlePrev, justify: 'flex-start' });
        } else if (opcion === 'solo-control-siguiente') {
            agregarBoton({ key: 'div-next-only', label: 'Siguiente', icon: 'pi pi-arrow-right', onClick: handleNext, justify: 'flex-end' });
        } else if (opcion === 'solo-control-ambos') {
            agregarBoton({ key: 'div-prev', label: 'Anterior', icon: 'pi pi-chevron-left', onClick: handlePrev, justify: 'flex-start' });
            agregarBoton({ key: 'div-next-only', label: 'Siguiente', icon: 'pi pi-arrow-right', onClick: handleNext, justify: 'flex-end' });
        } else {
            agregarBoton({ key: 'div-save', label: 'Guardar', icon: 'pi pi-save', type: 'submit', loading: loadingSave, className: 'p-button-warning', justify: 'center' });
        }

        return (
            <div className="formgrid grid mt-4">
                <div className="field col flex gap-2">
                    {botones}
                </div>
            </div>
        );
    };

    const handleNext = () => {
        if (activeIndex < 4) {
            setActiveIndex(activeIndex + 1);
        }
    };

    const handlePrev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };

    const registrar = (nuevo) => {
        setItem({ id: nuevo?.id });
    }

    const htmlPng = (ref) => {
        return new Promise((resolve, reject) => {
            if (!ref.current) { reject("No existe el nodo"); return; }
            toPng(ref.current, { cacheBust: true, backgroundColor: '#fff', scale: 1.2, }).then((dataUrl) => {
                resolve(dataUrl);
            }).catch((error) => {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Error al generar la imagen.', life: 3000 });
                reject(error);
            });
        });
    };

    const capturarGrafico = (refGrafico, nombreGrafico, tipo = "png") => {
        if (!refGrafico.current) return;
        setLoadingDescargarGrafico(true);
        htmlPng(refGrafico).then((imgData) => {
            if (tipo === "png") {
                const enlace = document.createElement("a");
                enlace.href = imgData;
                enlace.download = `${nombreGrafico}.png`;
                enlace.click();
            } else if (tipo === "pdf") {
                const fechaGeneracion = new Date().toLocaleDateString();
                const docDefinition = {
                    pageSize: "A4",
                    pageMargins: [40, 70, 40, 60],
                    header: {
                        margin: [40, 15, 40, 10],
                        stack: [
                            {
                                columns: [
                                    { text: riesgo?.nombre || '-', style: 'headerLeft', alignment: 'left' },
                                    { text: nombreGrafico, style: 'headerCenter', alignment: 'center' },
                                    { text: riesgo?.empresa || '-', style: 'headerRight', alignment: 'right' }
                                ],
                                columnGap: 10,
                                height: 60,
                                verticalAlignment: 'middle'
                            },
                            {
                                canvas: [
                                    { type: 'line', x1: 0, y1: 5, x2: 515, y2: 5, lineWidth: 1, lineColor: '#0055AA' }
                                ]
                            }
                        ]
                    },
                    footer: (currentPage, pageCount) => ({
                        columns: [
                            { text: `Generado: ${fechaGeneracion}`, alignment: 'left', fontSize: 9 },
                            { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', fontSize: 9 },
                            { text: `Estado: ${riesgo?.estado || '-'}`, alignment: 'right', fontSize: 9 }
                        ],
                        margin: [40, 10, 40, 0]
                    }),
                    content: [
                        {
                            columns: [
                                { text: `Área / Departamento: ${riesgo?.tipo_negocio || '-'}`, style: 'infoBoxLeft', alignment: 'left' },
                                { text: `Código de la matriz: ${riesgo?.sigla || '-'}`, style: 'infoBoxRight', alignment: 'right' },
                            ],
                            columnGap: 20,
                            margin: [0, 10, 0, 20]
                        },
                        {
                            stack: [
                                { image: imgData, width: 450, alignment: 'center', margin: [0, 50, 0, 0] }
                            ],
                            alignment: 'center',
                            margin: [0, 50, 0, 0]
                        }
                    ],
                    styles: {
                        headerLeft: { fontSize: 11, bold: true, color: '#0055AA' },
                        headerCenter: { fontSize: 14, bold: true, color: '#003366' },
                        headerRight: { fontSize: 11, bold: true, color: '#0055AA' },
                        infoBoxLeft: { fontSize: 11, bold: true, color: '#333333' },
                        infoBoxRight: { fontSize: 11, bold: true, color: '#333333' }
                    },
                    defaultStyle: { font: 'Roboto' }
                };
                pdfMake.createPdf(docDefinition).download(`${nombreGrafico || 'ReporteGrafico'}.pdf`);
            }
        }).catch(error => {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo capturar el gráfico', life: 3000 });
        }).finally(() => {
            setLoadingDescargarGrafico(false);
        });
    };

    const generarReporteGraficos = (riesgo) => {
        setLoadingReporte(true);
        const refs = {
            graficoRiesgoRef: graficoRiesgosRef,
            graficoPromedioRef: graficoPromedioRiesgosRef,
            graficoMapaCalorRIRef: graficoMapaRiesgoInherenteRef,
            graficoMapaCalorRRRef: graficoMapaRiesgoResidualRef
        };

        matrizSrv.consultar(riesgo?.id, 'matriz-riesgo/info-reporte').then(res => {
            return reporte(refs, res.data, labelMatriz);
        }).catch(error => {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Error al consultar la matriz.', life: 3000 });
        }).finally(() => {
            setLoadingReporte(false);
        });
    };

    const reporte = (refs, info, labelMatriz) => {
        const fechaGeneracion = new Date().toLocaleDateString();
        return Promise.all([
            htmlPng(refs.graficoRiesgoRef),
            htmlPng(refs.graficoPromedioRef),
            htmlPng(refs.graficoMapaCalorRIRef),
            htmlPng(refs.graficoMapaCalorRRRef),
        ]).then(([riesgosImg, promedioImg, mapaCalorRIImg, mapaCalorRRImg]) => {
            const docDefinition = {
                pageSize: "A4",
                pageMargins: [40, 80, 40, 60],
                header: {
                    margin: [40, 15, 40, 0],
                    stack: [
                        {
                            columns: [
                                info?.logo
                                    ? { image: info.logo, width: 60, alignment: 'left', margin: [0, 0, 0, 0] }
                                    : { text: '', width: 60 },
                                { text: info?.empresa || '', style: 'subheader', alignment: 'center', margin: [0, 15, 0, 0] },
                                { text: '', width: 60 }
                            ],
                            columnGap: 10,
                            verticalAlignment: 'middle'
                        },
                        { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 515, y2: 5, lineWidth: 1, lineColor: '#0055AA' }] }
                    ]
                },
                footer: (currentPage, pageCount) => ({
                    columns: [
                        { text: `Generado: ${fechaGeneracion}`, alignment: 'left', fontSize: 9, width: '33%' },
                        { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', fontSize: 9, width: '34%' },
                        { text: `Estado: ${info?.estado || '-'}`, alignment: 'right', fontSize: 9, width: '33%' }
                    ],
                    margin: [40, 10, 40, 0]
                }),

                content: [
                    { text: labelMatriz || 'Reporte de Riesgos', style: 'title', margin: [0, 0, 0, 10] },
                    {
                        table: {
                            widths: ['50%', '50%'],
                            body: [
                                [
                                    { text: `Área / Departamento: ${info?.tipo_negocio || '-'}`, style: 'infoCellLeft' },
                                    { text: `Código de la matriz: ${info?.sigla || '-'}`, style: 'infoCellRight' },
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: () => 0,
                            vLineWidth: () => 0,
                            fillColor: () => '#FFFFFF'
                        },
                        margin: [0, 0, 0, 5]
                    },
                    {
                        table: {
                            widths: ['50%', '50%'],
                            body: [
                                [
                                    { text: `Nombre de la matriz: ${info?.nombre || '-'}`, style: 'infoCellLeft' },
                                    { text: `Fecha de creación: ${info?.fecha || '-'}`, style: 'infoCellRight' },
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: () => 0,
                            vLineWidth: () => 0,
                            fillColor: () => '#FFFFFF'
                        },
                        margin: [0, 0, 0, 5]
                    },
                    { text: `Descripción: ${info?.descripcion || '-'}`, fontSize: 8, italics: true, alignment: 'center', margin: [0, 2, 0, 5] },
                    ...[
                        {
                            title: 'Promedio de Riesgos',
                            img: promedioImg,
                            description: `Promedio total de los Riesgos Inherentes y Riesgos Residuales de la matriz.`,
                            titleMargin: [0, 10, 0, 5],
                        },
                        {
                            title: 'Riesgos',
                            img: riesgosImg,
                            description: `Riesgo Inherente y Riesgo Residual de las actividades en la matriz.`,
                            titleMargin: [0, 10, 0, 15],
                        },
                        {
                            title: 'Mapa de Calor Riesgo Inherente',
                            img: mapaCalorRIImg,
                            description: 'Mapa de Calor de la consecuencia-impacto vs la probabilidad de los Riesgos Inherentes.',
                            titleMargin: [0, 30, 0, 5],
                        },
                        {
                            title: 'Mapa de Calor Riesgo Residual',
                            img: mapaCalorRRImg,
                            description: 'Mapa de Calor de la consecuencia-impacto vs la probabilidad de los Riesgos Residuales.',
                            titleMargin: [0, 35, 0, 5],
                        }
                    ].map(item => ({
                        stack: [
                            { text: item.title, style: 'subheader', margin: item.titleMargin || [0, 15, 0, 5] },
                            item.img ? { image: item.img, width: 450, alignment: 'center', margin: item.margin || [0, 0, 0, 10] } : { text: 'No disponible', alignment: 'center' },
                            { text: item.description, fontSize: 9, italics: true, margin: [0, 5, 0, 0], alignment: 'center' }
                        ],
                        pageBreak: item.pageBreak,
                    }))
                ],

                styles: {
                    title: { fontSize: 14, bold: true, color: '#0055AA', alignment: 'center' },
                    subheader: { fontSize: 12, bold: true, color: '#003366' },
                    headerEmpresa: { fontSize: 12, bold: true, color: '#0055AA', alignment: 'center' },
                    infoCellLeft: { fontSize: 11, bold: true, color: '#333333', alignment: 'left', margin: [5, 5, 5, 5] },
                    infoCellRight: { fontSize: 11, bold: true, color: '#333333', alignment: 'right', margin: [5, 5, 5, 5] },
                },
                defaultStyle: { fontSize: 10, alignment: 'center' }
            };
            pdfMake.createPdf(docDefinition).download(`${`${info.nombre} Gráficos` || 'Reporte Gráficos'}.pdf`);
        }).catch(error => {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo generar el reporte de gráficos.', life: 3000 });
        }).finally(() => {
            setLoadingReporte(false);
        });
    };

    const headerDialogPromedioRiesgos = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                <span>
                    <i className="pi pi-chart-bar mr-2"></i> Promedio de Riesgos
                </span>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Button icon="pi pi-image" className="p-button-primary" tooltip="Descargar gráfico en PNG" onClick={() => capturarGrafico(graficoRef, 'Promedio de Riesgos', 'png')} loading={loadingDescargarGrafico} />
                    <Button icon="pi pi-file-pdf" className="p-button-primary" tooltip="Descargar gráfico en PDF" onClick={() => capturarGrafico(graficoRef, 'Promedio de Riesgos', 'pdf')} loading={loadingDescargarGrafico} />
                </div>
            </div>
        );
    };

    const headerDialogRiesgo = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                <span>
                    <i className="pi pi-chart-bar mr-2"></i> Gráfico de Riesgos
                </span>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Button icon="pi pi-image" className="p-button-primary" tooltip="Descargar gráfico en PNG" onClick={() => capturarGrafico(graficoRef, 'Riesgos', 'png')} loading={loadingDescargarGrafico} />
                    <Button icon="pi pi-file-pdf" className="p-button-primary" tooltip="Descargar gráfico en PDF" onClick={() => capturarGrafico(graficoRef, 'Riesgos', 'pdf')} loading={loadingDescargarGrafico} />
                </div>
            </div>
        );
    };

    const headerDialogMapaCalor = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                <span>
                    <i className="pi pi-chart-scatter mr-2"></i> Mapa de Calor
                </span>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Button icon="pi pi-image" className="p-button-primary" tooltip="Descargar gráfico en PNG" onClick={() => capturarGrafico(graficoRef, 'Mapa de Calor', 'png')} loading={loadingDescargarGrafico} />
                    <Button icon="pi pi-file-pdf" className="p-button-primary" tooltip="Descargar gráfico en PDF" onClick={() => capturarGrafico(graficoRef, 'Mapa de Calor', 'pdf')} loading={loadingDescargarGrafico} />
                </div>
            </div>
        );
    }

    const dialogCriterioConsecuenciaHeader = () => {
        return (
            <div>
                <i className="pi pi-cog" />
                <span className="title-header">{' '}Configuración de criterios y consecuencias</span>
            </div>
        );
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const getMenuItems = () => {
        let items = [];

        if (riesgo?.nemonico === 'BORRADOR' || riesgo?.nemonico === 'ENVIADO') {
            items.push({
                label: 'Configuración',
                items: [
                    {
                        label: 'Ordenar actividades',
                        icon: 'pi pi-sort text-orange-500',
                        command: () => setDialogOrdenarActividades(true)
                    },
                    {
                        label: 'Configurar criterios y consecuencias',
                        icon: 'pi pi-cog text-bluegray-500',
                        command: () => setDialogCriterioConsecuencia(true)
                    },
                ]
            });
        }

        items.push({
            label: 'Visualización',
            items: [
                {
                    label: 'Gráfico de riesgos',
                    icon: 'pi pi-chart-bar text-purple-500',
                    command: () => setDialogChart(true)
                },
                {
                    label: 'Mapa de calor',
                    icon: 'pi pi-chart-scatter text-pink-500',
                    command: () => setDialogMapaCalor(true)
                },
                {
                    label: 'Ver promedio de riesgos',
                    icon: 'pi pi-clipboard text-teal-500',
                    command: () => setDialogPromedio(true)
                }
            ]
        });

        items.push({
            label: 'Reportes',
            items: [
                {
                    label: 'Imprimir gráficos',
                    icon: 'pi pi-chart-pie text-blue-500',
                    command: () => generarReporteGraficos(riesgo),
                    disabled: loadingReporte || loadingTabla || loadingEnviarFinalizar
                },
                {
                    label: 'Imprimir a PDF',
                    icon: 'pi pi-print text-red-500',
                    command: () => generarReporte(riesgo, 'matriz'),
                    disabled: loadingReporte || loadingTabla || loadingEnviarFinalizar
                }
            ]
        });

        return items;
    };

    return (
        <>
            <Card title={labelMatriz} className="mb-4 shadow-2 border-round-2xl" style={{ paddingLeft: '1rem', backgroundColor: '#ffffff', borderLeft: '6px solid #30363c', }}
                pt={{
                    body: { style: { paddingTop: 5, paddingBottom: 5 } },
                }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: '1rem' }}>
                    <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', flex: 1, alignSelf: 'center' }}>
                        <div style={{ marginRight: '10px' }}>
                            <h3 style={{ margin: 0, color: '#003366', fontFamily: 'Segoe UI, sans-serif' }}>
                                {riesgo.nombre}
                            </h3>
                            <Tag value={riesgo.sigla} severity="info" style={{ backgroundColor: '#f8f9fa', color: '#003366', marginTop: '0.25rem' }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right', marginRight: '10px' }}>
                            <small style={{ color: '#888' }}>Fecha</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {riesgo.fecha}
                            </span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <small style={{ color: '#888' }}>Detalle</small>
                            <span style={{ color: '#003366', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {riesgo.descripcion}
                            </span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        {permss?.consultar && (
                            <>
                                {dialogActividad ? (
                                    <Button icon="pi pi-arrow-left" className="p-button-primary" tooltip="Regresar a la lista de actividades" tooltipOptions={{ position: 'left' }} onClick={() => { setDialogActividad(false); setActiveIndex(0); loadLazyData(); }} style={{ height: '2.5rem' }} />
                                ) : (
                                    <Button icon="pi pi-arrow-left" className="p-button-primary" tooltip="Regresar al listado de matrices de riesgos" tooltipOptions={{ position: 'left' }} onClick={() => regresar(false)} style={{ height: '2.5rem' }} />
                                )}
                                {!dialogActividad && (
                                    <>
                                        <Menu model={getMenuItems()} popup ref={menuRef} id="popup_menu_actions" />
                                        <Button icon="pi pi-bars" className="p-button-secondary" tooltip="Más opciones" tooltipOptions={{ position: 'left' }} onClick={(event) => menuRef.current.toggle(event)} aria-controls="popup_menu_actions" aria-haspopup style={{ height: '2.5rem' }} />
                                    </>
                                )}
                            </>
                        )}
                        {!dialogActividad && permss?.crear && (riesgo?.nemonico === 'BORRADOR' || riesgo?.nemonico === 'ENVIADO') && (
                            <Button icon="pi pi-plus" className="p-button-success" tooltip="Agregar nueva actividad" tooltipOptions={{ position: 'left' }} onClick={() => nuevo()} style={{ height: '2.5rem' }} disabled={loadingReporte || loadingTabla || loadingEnviarFinalizar} />
                        )}
                    </div>
                </div>
            </Card>
            <table style={{ width: '100%', marginBottom: '0.5rem', borderCollapse: 'separate', borderSpacing: 0, textAlign: 'center', fontSize: '0.8rem', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden', }}>
                <thead>
                    <tr style={{ backgroundColor: '#003366', color: 'white' }}>
                        <th colSpan={2} style={{ padding: '0.2rem' }}>
                            NIVEL(ES) DE RIESGO INHERENTE ACEPTADO
                        </th>
                        <th colSpan={2} style={{ padding: '0.2rem' }}>
                            NIVEL(ES) DE RIESGO RESIDUAL ACEPTADO
                        </th>
                    </tr>
                    <tr style={{ backgroundColor: '#e0e0e0', color: '#333' }}>
                        <th style={{ padding: '0.1rem' }}>APETITO</th>
                        <th style={{ padding: '0.1rem' }}>TOLERANCIA</th>
                        <th style={{ padding: '0.1rem' }}>APETITO</th>
                        <th style={{ padding: '0.1rem' }}>TOLERANCIA</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ backgroundColor: '#f9f9f9' }}>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {riesgo.apetito_inherente}
                        </td>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {riesgo.tolerancia_inherente}
                        </td>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {riesgo.apetito_residual}
                        </td>
                        <td style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            {riesgo.tolerancia_residual}
                        </td>
                    </tr>
                </tbody>
            </table>
            {!dialogActividad && table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            {dialogActividad &&
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Establecimiento del Contexto" leftIcon="pi pi-address-book mr-2">
                        <Actividad riesgo={riesgo} id={item?.id} toast={toast} permss={permss} generic={generic} seccion="seccion1" nextPrev={nextPrev} handleNext={handleNext}
                            registrar={registrar} siguienteTab={siguienteTab} setSiguienteTab={setSiguienteTab} setLoadingSave={setLoadingSave} setLoadingNext={setLoadingNext} funcionalidades={funcionalidades} />
                    </TabPanel>
                    <TabPanel header="Nivel de Riesgo Inherente" leftIcon="pi pi-bolt mr-2" disabled={!item?.id}>
                        <Amenaza riesgo={riesgo} id={item?.id} toast={toast} permss={permss} generic={generic} seccion="seccion2" nextPrev={nextPrev} handleNext={handleNext}
                            siguienteTab={siguienteTab} setSiguienteTab={setSiguienteTab} setLoadingSave={setLoadingSave} setLoadingNext={setLoadingNext} funcionalidades={funcionalidades} />
                    </TabPanel>
                    <TabPanel header="Controles" leftIcon="pi pi-check mr-2" disabled={!item?.id}>
                        <ControlImplementado riesgo={riesgo} id={item?.id} toast={toast} permss={permss} generic={generic} seccion="seccion3" nextPrev={nextPrev} handleNext={handleNext} funcionalidades={funcionalidades} />
                    </TabPanel>
                    <TabPanel header="Nivel de Riesgo Residual" leftIcon="pi pi-wave-pulse mr-2" disabled={!item?.id}>
                        <Evaluacion riesgo={riesgo} id={item?.id} toast={toast} permss={permss} generic={generic} seccion="seccion4" nextPrev={nextPrev} handleNext={handleNext}
                            siguienteTab={siguienteTab} setSiguienteTab={setSiguienteTab} setLoadingSave={setLoadingSave} setLoadingNext={setLoadingNext} funcionalidades={funcionalidades} />
                    </TabPanel>
                    <TabPanel header="Comunicación - Plan de Contingencia" leftIcon="pi pi-calendar mr-2" disabled={!item?.id}>
                        <Contingencias riesgo={riesgo} id={item?.id} toast={toast} permss={permss} generic={generic} seccion="seccion5" nextPrev={nextPrev} handleNext={handleNext} funcionalidades={funcionalidades} />
                    </TabPanel>
                </TabView>
            }
            {/* Renderizamos los gráficos para que estén disponibles para la captura, los sacamos de la pantalla */}
            <div style={{ position: "absolute", top: "-9999px", left: "-9999px", pointerEvents: "none" }}>
                <RiesgoChart datos={datosGrafico} maximo={5} titulo={"Nivel de Riesgo"} graficoRef={graficoRiesgosRef} />
                <div style={{ width: '850px', height: '550px' }}>
                    <PromedioRiesgo matrizId={riesgo?.id} permss={permss} toast={toast} generic={generic} graficoRef={graficoPromedioRiesgosRef} refrescar={refrescarGrafico} />
                </div>
                <MapaCalorRiesgo matrizId={riesgo?.id} permss={permss} toast={toast} generic={generic} graficoRef={graficoMapaRiesgoInherenteRef} defaultTab={0} refrescar={refrescarGrafico} />
                <MapaCalorRiesgo matrizId={riesgo?.id} permss={permss} toast={toast} generic={generic} graficoRef={graficoMapaRiesgoResidualRef} defaultTab={1} refrescar={refrescarGrafico} />
            </div>
            <Dialog header={headerDialogRiesgo()} visible={dialogChart} onHide={() => { setDialogChart(false) }} className="dialog-personalizado" modal style={{ width: '850px', height: '550px' }}>
                <RiesgoChart datos={datosGrafico} maximo={5} titulo={"Nivel de Riesgo"} graficoRef={graficoRef} />
            </Dialog>
            <Dialog header={headerDialogPromedioRiesgos()} visible={dialogPromedio} onHide={() => { setDialogPromedio(false) }} className="dialog-personalizado" modal style={{ width: '850px', height: '550px' }}>
                <PromedioRiesgo matrizId={riesgo?.id} permss={permss} toast={toast} generic={generic} graficoRef={graficoRef} />
            </Dialog>
            <Dialog header={headerDialogMapaCalor()} visible={dialogMapaCalor} style={{ width: '700px' }} modal onHide={() => setDialogMapaCalor(false)} className="dialog-personalizado">
                <MapaCalorRiesgo matrizId={riesgo?.id} permss={permss} toast={toast} generic={generic} graficoRef={graficoRef} />
            </Dialog>
            <Dialog header={<span><i className="pi pi-list mr-2"></i> Actualizar el orden de actividades</span>} visible={dialogOrdenarActividades} style={{ width: '700px' }} modal onHide={() => setDialogOrdenarActividades(false)} className="dialog-personalizado">
                <ActividadesOrden matrizId={riesgo?.id} toast={toast} permss={permss} generic={generic} onClose={() => { setDialogOrdenarActividades(false); loadLazyData() }} />
            </Dialog>
            <Dialog visible={dialogCriterioConsecuencia} header={dialogCriterioConsecuenciaHeader} modal className="p-fluid dialog-personalizado"
                onHide={() => { setDialogCriterioConsecuencia(false); }} style={{ width: '1000px', height: '800px' }}>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Criterios" leftIcon="pi pi-list-check mr-2">
                        <Accordion>
                            {tiposCriterio.map(({ tipo, nombre, listar, padre }) => (
                                <AccordionTab key={tipo} header={nombre}>
                                    <CriteriosGeneral permss={permss} toast={toast} generic={generic} riesgo={riesgo} tipo={tipo} listar={listar} padreTipo={padre} funcionalidades={funcionalidades} />
                                </AccordionTab>
                            ))}
                        </Accordion>
                    </TabPanel>
                    <TabPanel header="Consecuencias" leftIcon="pi pi-exclamation-triangle mr-2">
                        <Accordion>
                            {tiposConsecuencia.map(({ tipo, nombre }) => (
                                <AccordionTab key={tipo} header={nombre}>
                                    <ConsecuenciasGeneral permss={permss} toast={toast} generic={generic} riesgo={riesgo} tipo={tipo} funcionalidades={funcionalidades} />
                                </AccordionTab>
                            ))}
                        </Accordion>
                    </TabPanel>
                </TabView>
            </Dialog>
        </>
    )
}
